import { render, staticRenderFns } from "./LoyaltyMenu.vue?vue&type=template&id=e96e3194&"
import script from "./LoyaltyMenu.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports